import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';
import FormOverlay from "../../../../components/Modal";

class AdkFeedTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            whitelist: {
                opened: false,
                text: ""
            }
        }
    }

    render() {
        const { feeds, partners, onRemove, onUpdate, handleFormSubmit, onSort } = this.props;
        const { whitelist } = this.state;

        const rows = feeds.map((feed, index) => <Row showWhitelist={(whitelist) => this.setState({ whitelist: { opened: true, text: whitelist } })} key={index} feed={feed} partners={partners} onUpdate={onUpdate} onRemove={onRemove} handleFormSubmit={handleFormSubmit}/>);

        return (
            <div>
                {whitelist.opened && (
                    <FormOverlay onHide={() => this.setState({ whitelist: { opened: false, text: "" } })} >
                        <div style={{ justifyContent: 'center', display: 'flex', padding: 25, wordBreak: 'break-word' }}>
                            <span style={{ wordWrap: "break-word" }}>{whitelist.text || "Empty whitelist"}</span>
                        </div>
                    </FormOverlay>
                )}

                <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <thead>
                    <tr>
                        <th onClick={() => onSort('id')}>ID</th>
                        <th onClick={() => onSort('name')}>Name</th>
                        <th onClick={() => onSort('type')}>Type</th>
                        <th onClick={() => onSort('creative')}>Creative</th>
                        <th onClick={() => onSort('auth')}>Auth</th>
                        <th onClick={() => onSort('factor')}>Factor</th>
                        <th onClick={() => onSort('partner')}>Partner</th>
                        <th onClick={() => onSort('zone')}>Zone</th>
                        <th onClick={() => onSort('device')}>Device</th>
                        <th onClick={() => onSort('roi')}>ROI</th>
                        <th onClick={() => onSort('cpm')}>CPM</th>
                        <th>Whitelist</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default AdkFeedTable;



// WEBPACK FOOTER //
// ./src/scenes/AdkFeeds/components/Table/index.js